import * as React from 'react'
import { IProps } from '../../types'

const FormsIcon = ({ className }: IProps) => (
  <div className={className}>
    <svg
      width="94"
      height="132"
      viewBox="0 0 94 132"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d)">
        <rect
          x="7.48474"
          y="24.0589"
          width="77.0303"
          height="95"
          fill="white"
        />
        <path
          d="M26.1218 16.7065V30.1869V33.8634H64.637V16.7065H58.4249L55.94 10.579L48.4855 4.4516H43.5158L34.8188 10.579V16.7065H26.1218Z"
          fill="#FFE600"
        />
        <path
          d="M7.84942 20.7129H23.9961V15.6634C23.9961 14.4752 25.2625 13.2871 26.8456 13.2871H31.9112C33.1776 6.75248 39.193 2 46.1583 2C53.1236 2 59.139 6.75248 60.0888 13.2871H65.471C66.7374 13.2871 68.0039 14.4752 68.0039 15.9604V20.7129H84.4672C86.0502 20.7129 87 21.901 87 23.3861V119.327C87 120.812 86.0502 122 84.4672 122H7.53282C6.26641 122 5 120.812 5 119.327V23.3861C5 21.901 6.26641 20.7129 7.84942 20.7129ZM29.3784 29.3267H62.6216C62.6216 25.4653 62.6216 21.901 62.6216 18.3366H57.556C55.6564 18.3366 55.0232 16.8515 55.0232 15.3663C55.0232 10.6139 50.9073 7.04951 46.1583 7.04951C41.0927 7.04951 37.2934 10.6139 37.2934 15.3663C37.2934 16.8515 36.6602 18.3366 34.444 18.3366H29.3784C29.3784 21.901 29.3784 25.4653 29.3784 29.3267ZM65.1544 34.3762H26.8456C25.2625 34.3762 23.9961 33.1881 23.9961 31.703V25.7624H10.3822V116.95H81.6178V25.7624H68.0039V31.703C68.0039 33.1881 66.7375 34.3762 65.1544 34.3762Z"
          fill="#413E4D"
        />
        <path
          d="M20.5138 50.8366C18.9308 50.8366 17.6644 49.599 17.6644 48.052C17.6644 46.8143 18.9308 45.5767 20.5138 45.5767H60.7223C61.9888 45.5767 63.2552 46.8143 63.2552 48.052C63.2552 49.599 61.9888 50.8366 60.7223 50.8366H20.5138Z"
          fill="#413E4D"
        />
        <path
          d="M20.5139 67.854C18.9308 67.854 17.6644 66.6164 17.6644 65.3788C17.6644 63.8317 18.9308 62.5941 20.5139 62.5941H71.8034C73.0698 62.5941 74.3363 63.8317 74.3363 65.3788C74.3363 66.6164 73.0698 67.854 71.8034 67.854H20.5139Z"
          fill="#413E4D"
        />
        <path
          d="M20.5139 84.8714C18.9308 84.8714 17.6644 83.9431 17.6644 82.3961C17.6644 80.8491 18.9308 79.6115 20.5139 79.6115H71.8034C73.0698 79.6115 74.3363 80.8491 74.3363 82.3961C74.3363 83.9431 73.0698 84.8714 71.8034 84.8714H20.5139Z"
          fill="#413E4D"
        />
        <path
          d="M20.5139 102.198C18.9308 102.198 17.6644 100.96 17.6644 99.4134C17.6644 98.1758 18.9308 96.9382 20.5139 96.9382H71.8034C73.0698 96.9382 74.3363 98.1758 74.3363 99.4134C74.3363 100.96 73.0698 102.198 71.8034 102.198H20.5139Z"
          fill="#413E4D"
        />
      </g>
      <defs>
        <filter
          id="filter0_d"
          x="0"
          y="0"
          width="94"
          height="132"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dx="1" dy="4" />
          <feGaussianBlur stdDeviation="3" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  </div>
)

export default FormsIcon



// WEBPACK FOOTER //
// ./src/components/Icons/components/FormsIcon/index.tsx